import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=dfe6d72e&scoped=true&"
import script from "./cooperation.vue?vue&type=script&lang=js&"
export * from "./cooperation.vue?vue&type=script&lang=js&"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=dfe6d72e&prod&lang=scss&scoped=true&"
import style1 from "./cooperation.vue?vue&type=style&index=1&id=dfe6d72e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe6d72e",
  null
  
)

export default component.exports